module.exports = __webpack_public_path__ + "media/images/tmp/ig2-bd63e5ec00e82f8104f0e0fbf06f18b9.png";